module.exports = require("core-js/library/fn/number/min-safe-integer");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/number/min-safe-integer.js
// module id = 116
// module chunks = 35783957827783 114276838955818 162898551421021